module.exports = "<ng-template #caregiverActive>{{ 'TOOLTIP.STATUS-ACTIVE' | translate }}</ng-template>\r\n<ng-template #caregiverInactive>{{ 'TOOLTIP.STATUS-INACTIVE' | translate }}</ng-template>\r\n\r\n<span class=\"status {{size}}\" [ngClass]=\"{'active': status==true}\" placement=\"bottom\" [ngbTooltip]=\"(status) ? caregiverActive:caregiverInactive\"></span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/check-status/check-status.component.html
// module id = ./src/app/shared/components/check-status/check-status.component.html
// module chunks = main